
(function(template){
    define('vue!app/views/vue/components/packageDivComponent/breadCrumbs',['Vue','vuex'],function(Vue,vuex){
        return {
            template:template,
            computed:{
                activeStep: function(){
                    return this.$store.state.activeStep;
                },
                locationDetails: function() {
                    return app.models.spaModel.getSelectedItem('spaLocations', {});
                }
            },
            methods: {
                handleKeyDown: function(e) {
                    this.a11yKeyDown(e, {
                        enter: function(){
                            e.target.click();
                        }
                    })
                },
                goBack: function(){
                    var nextStep = this.activeStep == 2 ? 0 : this.activeStep-1;
                    if(nextStep<0) app.dispatcher.redirect('spaBooking');
                    else this.$store.commit('setActiveStep',nextStep);
                },
                goto: function(step){
                    if(step == this.activeStep) return;
                    this.$store.commit('setActiveStep',step);
                }
            }
        }
    })
})('<div class="yellowHeader breakcrumbs"> <i @click="goBack" @keydown="handleKeyDown" tabindex="0" class="fas fa-chevron-left"></i> <a href=\'#/spaBooking\'>{{locationDetails.LocationName}}</a> <span @keydown="handleKeyDown" :tabindex="activeStep > 0 ? 0 : -1" :class="{\'pointer underLined\': activeStep > 0}" v-if="activeStep >= 0" @click="goto(0)">/ {{localStrings.breadcrumbs.select}}</span> <span @keydown="handleKeyDown" :tabindex="activeStep > 1 ? 0 : -1" :class="{\'pointer underLined\': activeStep > 1}" v-if="activeStep == 1" @click="goto(1)">/ {{localStrings.breadcrumbs.schedule}}</span> <span v-if="activeStep >= 2" @click="goto(2)">/ {{localStrings.breadcrumbs.review}}</span> </div>');
